const BANDCAMP_BASE = 'https://funusbandofficial.bandcamp.com';

const ENTITIES = {
    '&amp;': '&',
    '&ndash;': '–',
    '&mdash;': '—',
    '&euro;': '€',
    '&quot;': '"',
    '&#39;': '\'',
    '&apos;': '\'',
    '&nbsp;': ' ',
};

function decodeEntities(value) {
    return value
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
        .replace(/&[a-z]+;/gi, (entity) => (entity in ENTITIES ? ENTITIES[entity] : entity));
}

function clean(value) {
    return decodeEntities(String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ')).trim();
}

function firstMatch(chunk, pattern) {
    const match = chunk.match(pattern);

    return match ? match[1] : '';
}

export default function parseMerchHtml(html) {
    if (!html) {
        return [];
    }

    const gridStart = html.indexOf('id="merch-grid"');

    if (gridStart === -1) {
        return [];
    }

    const gridEnd = html.indexOf('</ol>', gridStart);
    const grid = html.slice(gridStart, gridEnd === -1 ? undefined : gridEnd);
    const chunks = grid.split(/<li\b/).slice(1);
    const items = [];

    chunks.forEach((chunk) => {
        if (!/merch-grid-item/.test(chunk)) {
            return;
        }

        const href = firstMatch(chunk, /<a\s+href="([^"]*)"/);
        const url = href.startsWith('http') ? href : `${BANDCAMP_BASE}${href}`;

        items.push({
            id: firstMatch(chunk, /data-item-id="([^"]*)"/),
            title: clean(firstMatch(chunk, /<p class="title">([\s\S]*?)<\/p>/)),
            type: clean(firstMatch(chunk, /class="merchtype[^"]*">([\s\S]*?)<\/div>/)),
            price: clean(firstMatch(chunk, /<span class="price">([\s\S]*?)<\/span>/)),
            currency: clean(firstMatch(chunk, /<span class="currency">([\s\S]*?)<\/span>/)),
            imageSrc: firstMatch(chunk, /<img[^>]*\bsrc="([^"]*)"/),
            url,
            soldOut: /sold[- ]?out/i.test(chunk),
        });
    });

    return items;
}

export { BANDCAMP_BASE };
